export function convertClock(clock) {
  let clockDisplay = clock.replace("PT", "").replace("S", "");
  let clockParts = clockDisplay.split("M");
  clockDisplay =
    ("0" + clockParts[0]).slice(-2) + ":" + ("0" + clockParts[1]).slice(-2);
  return clockDisplay;
}

export function convertDisplayTimeToDataTime(displayTime) {
  let clockParts = displayTime.split(":");
  return "PT" + parseInt(clockParts[0]) + "M" + parseInt(clockParts[1]) + "S";
}
